module.exports = __webpack_public_path__ + "media/images/calderon-3f5d6131891e37d8709525fb25d34119.jpg";